<template>
  <div>
    <h3 class="text-dark-muted heading">{{ title }}</h3>
    <slot></slot>
    <div class="divider-v w-100 mx-0 my-2"></div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'lp-expandable-section',
}
</script>
<script lang="ts" setup>
defineProps<{
  title: string
}>()
</script>

<style scoped>
.heading {
  margin-top: -1.5rem;
}
</style>
